/* eslint-disable */
//tslint:disable

export interface IUndergroundSchema {
  /** Цвет ветки, hex (e.g. 009BD5) **/
  color: string;
  /** Название станции **/
  name: string;
  /** Время до станции в минутах **/
  travelTime: number;
  /** Как добираться до станции **/
  travelType: ETravelType;
}

export enum ETravelType {
  /** На машине **/
  ByCar = 'byCar',
  /** Пешком **/
  ByFoot = 'byFoot',
}
